<div class="planned-assignment-list-entry" [ngClass]="{'selected' : selected}" matRipple *ngIf="transportDetails">
  <sc-flex>
    <app-transport-scope-icon [scope]="transportDetails.scope"></app-transport-scope-icon>
    <div class="title">{{transportDetails.identifyingNumberplate}}</div>
    <sc-content-spacer grow></sc-content-spacer>
    <div class="duration">{{transportDetails.processing.processingTime}}</div>
  </sc-flex>
  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
  <sc-flex>
    <div class="carrier">{{transportDetails.masterdata.carrier}}</div>
  </sc-flex>
  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
  <sc-flex>
    <ng-container *ngIf="transportDetails?.timing.planningDate">
      <sc-icon iconClass="fa-calendar"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
      {{transportDetails?.timing.planningDate | timestamp }}
      <ng-container *ngIf="transportDetails?.timing.timeSlotDelay">(+{{transportDetails?.timing.timeSlotDelay}})
      </ng-container>
    </ng-container>
    <sc-content-spacer grow></sc-content-spacer>

    <div class="status-icon" *ngIf="transportDetails.masterdata.important">
      <sc-icon iconClass="fa-exclamation"></sc-icon>
    </div>
    <div class="status-icon" *ngIf="transportDetails.masterdata.dangerousGoods">
      <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
    </div>
    <div class="status-icon" *ngIf="transportDetails.processing.pendingTaskState !== TransportTaskStatus.NONE">
      <app-task-state-icon [state]="transportDetails.processing.pendingTaskState"></app-task-state-icon>
    </div>
    <div class="status-icon" *ngIf="transportDetails.masterdata.urgent">
      <sc-icon iconClass="fa-truck-fast"></sc-icon>
    </div>
    <div class="status-icon" *ngIf="transportDetails.processing.inUmbrueckung">
      <sc-icon iconClass="fa-random"></sc-icon>
    </div>
  </sc-flex>
</div>
